import CarDetails from "../../Components/Cars/CarDetails";

function CarShow() {
  return (
    <div>
      <CarDetails />
    </div>
  );
}

export default CarShow;
